import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=0ee56aeb&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee56aeb",
  null
  
)

export default component.exports